import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Container, Title, Breadcrumbs, Anchor } from '@mantine/core';
import { UploadPage } from './pages/UploadPage';

/**
 * Layout component for the domain-bulk-import module
 * Provides routing structure and navigation breadcrumbs
 */
export const DomainBulkImportLayout: React.FC = () => {
  return (
    <Container size="xl" py="md">
      <Breadcrumbs mb="md">
        <Anchor href="/domain-names">Domain Names</Anchor>
        <span>Bulk Import</span>
      </Breadcrumbs>
      
      <Title order={1} mb="lg">
        Domain Bulk Import
      </Title>
      
      <Routes>
        <Route path="upload" element={<UploadPage />} />
        <Route path="/" element={<Navigate to="upload" replace />} />
        <Route path="*" element={<Navigate to="upload" replace />} />
      </Routes>
    </Container>
  );
};